import { useState, useEffect, useCallback, useRef } from 'react';
import {
  getHeadersUnwrapped,
  useUserContext,
  IError,
} from '../common';
import { IStatusLegacies, searchLegacyStatus } from '.';
import { fold } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';

export const useLegacyRequestSearch = ({
  page,
  pageSize,
  searchBy,
  searchP1,
  searchP2,
}: {
  page: number;
  pageSize: number;
  searchBy: string;
  searchP1: string;
  searchP2: string;
}) => {
  const { user } = useUserContext();

  const [requestStatus, setRequestStatus] = useState<IStatusLegacies>({
    total: 0,
    content: [],
  });

  const [call, setCall] = useState<boolean | null>(null);

  const paramsRef = useRef({ page, pageSize, searchBy, searchP1, searchP2, user });
  useEffect(() => { paramsRef.current = { page, pageSize, searchBy, searchP1, searchP2, user }; });

  useEffect(() => {
    if (call !== null) return;
    const p = paramsRef.current;
    flow(getHeadersUnwrapped, searchLegacyStatus)(p.user)({
      page: p.page, pageSize: p.pageSize, searchBy: p.searchBy,
      searchP1: p.searchP1, searchP2: p.searchP2,
    }).then(fold<IError, IStatusLegacies, void>(
      () => { setRequestStatus({ total: 0, content: [] }); setCall(false); },
      data => { setRequestStatus(data); setCall(true); }
    ));
  }, [call]);

  const search = useCallback(() => setCall(null), []);
  return {
    requestStatus,
    call,
    search,
  };
};
